import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IAuthState } from '../types'
import { initialize, getUser } from '../services'

export const initialState: IAuthState = {
  initialized: false,
  user: { authenticated: false, info: null },
}

const initializeAuth = createAsyncThunk('auth/initializeAuth', initialize)

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initializeAuth.fulfilled, (state: IAuthState) => {
      state.initialized = true
      state.user = getUser()
    })
  },
})
export { initializeAuth }
export default authSlice.reducer
